<template>
	<div>
		<div class='items_group_item' v-for='(item,index) in items' v-bind:key="'item'+index" @click="goTo(item.url)">
			<div class='items_group_item_img'>
				<img :src='item.picture'/>
			</div>
			<div class='items_group_item_content'>
				<span>{{item.name}}</span>
				<span class='items_group_item_content_price'><span class='items_group_item_content_price_old' v-if='item.oldprice'>{{item.oldprice}}</span> {{item.price}} {{item.currency}}</span>
			</div>
		</div>
	</div>
</template>

<script>
	import sendStats from '../helpers/sendStats';
	export default {
		name: "ItemComponent",
		props: ['items'],
		inject: ['searchdata','customer_id'],
		methods: {
			async goTo($url) {
				sendStats(this.customer_id, this.searchdata.total, this.searchdata.searchText, this.searchdata.hash, 1, $url)
				window.location.href=$url;
			}
		}
	}
</script>

<style scoped lang='scss'>
	.items
	{
		&_group
		{
			margin: 0 30px 20px 0;
			flex: 0 0 30%;
			&_title
			{
				font-size: 26px;
				border-bottom: 1px solid #e6e6e6;
				padding-bottom: 5px;
				margin-bottom: 10px;
			}

			&_item
			{
				display: flex;
				margin-bottom: 10px;
				cursor: pointer;
				&:hover
				{
					background: #d3d3d338;
				}
				&_img
				{
					display: flex;
					justify-content: center;
					border: 1px solid #eee;
					margin-right: 15px;
					width: 80px;
					height: 80px;
					position: static;
					align-items: center;

					img
					{
						max-width: 100%;
						max-height: 100%;
					}

				}
				&_content
				{
					flex: 1;
					display: flex;
					flex-direction: column;
					justify-content: space-evenly;
					word-break: break-word;
					&_price
					{
						color: rgba(0, 0, 0, .55);
						&_old
						{
							text-decoration: line-through;
							opacity: 0.6;
						}
					}
				}
			}
			&_more
			{
				color: rgba(100, 119, 136, .7);
				cursor: pointer;
			}

		}
	}
</style>